// extracted by mini-css-extract-plugin
export default {"slide":"qdtS9","card":"GRI0F","innerSize--full":"oavc7","image":"b9OOu","image-popup":"snU81","text":"wtBQn","slide-active":"WKL4t"};